module.exports = __webpack_public_path__ + "img/yiyuanimg.2d55545d.jpg";